<template>
  <div
    class="bp-radio"
    :class="{
      'flex-column justify-content-start': vertical,
      'flex-row align-items-start gap-5': !vertical
    }"
  >
    <label v-if="label">
      <span class="text-semibold fs-14 mr-3">{{ label }}</span>
    </label>

    <div
      v-for="option in options"
      :key="option.id"
      class="bp-radio__option-wrapper"
    >
      <div class="bp-radio__option">
        <input
          v-model="innerValue"
          type="radio"
          class="bp-radio__input"
          :id="id + '-' + option.id"
          :value="option.id"
          :disabled="disabled || option.disabled"
        />

        <label class="functional-1 bp-radio__label" :for="id + '-' + option.id">
          <span>
            {{ option.name }}
          </span>
          <bp-tooltip v-if="option.warning" :text="option.warning">
            <i class="fa fa-circle-exclamation fs-14 ml-3 text-neutral-500" />
          </bp-tooltip>
        </label>
      </div>

      <div
        v-if="option.description"
        class="functional-2 bp-radio__option-description pl-2"
      >
        {{ option.description }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: "bp-radio"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal;
    },
    innerValue(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-radio {
  display: flex;

  .bp-radio__option {
    display: flex;
    align-items: center;
    gap: 4px;

    .bp-radio__input {
      transform: none;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      &::after {
        padding: 0;
        width: 18px;
        height: 18px;
        font-size: 18px;
        padding-bottom: 3px;
        border-color: var(--dark-20);
        transition: 0.2s all;
      }
      &:checked {
        &::after {
          background: black;
          border-color: var(--dark-40);
        }
      }
      &:disabled {
        &:checked {
          &::after {
            background-color: var(--dark-40);
            border-color: transparent;
          }
        }
      }
    }

    .bp-radio__label {
      margin: 0;
      display: flex;
      color: var(--dark);
      align-items: center;
    }
    .bp-radio__input:disabled + .bp-radio__label span {
      color: var(--dark-40);
    }
  }
}
</style>
